/**
 * WHYSHIFT scroll-snap carousel — minimal arrow controls.
 * Scoped to <whyshift-carousel> custom elements only.
 */
class WhyshiftCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-whyshift-carousel-track]');
    this.prevButton = this.querySelector('[data-whyshift-carousel-prev]');
    this.nextButton = this.querySelector('[data-whyshift-carousel-next]');

    if (!this.track) return;

    this.#onScroll = this.#updateButtons.bind(this);
    this.track.addEventListener('scroll', this.#onScroll, { passive: true });

    this.prevButton?.addEventListener('click', () => this.#scrollBySlide(-1));
    this.nextButton?.addEventListener('click', () => this.#scrollBySlide(1));

    this.#updateButtons();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.#onScroll);
  }

  #onScroll;

  #scrollBySlide(direction) {
    const slide = this.track.querySelector('.whyshift-carousel__slide');
    if (!slide) return;

    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const distance = slide.offsetWidth + gap;

    this.track.scrollBy({
      left: distance * direction,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  #updateButtons() {
    if (!this.track) return;

    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const atStart = this.track.scrollLeft <= 1;
    const atEnd = this.track.scrollLeft >= maxScroll - 1;

    if (this.prevButton) this.prevButton.disabled = atStart;
    if (this.nextButton) this.nextButton.disabled = atEnd;
  }
}

if (!customElements.get('whyshift-carousel')) {
  customElements.define('whyshift-carousel', WhyshiftCarousel);
}

function loadSeenWorldRescue() {
  if (!document.querySelector('.whyshift-seen-world__placeholder')) return;
  if (document.querySelector('script[src*="whyshift-seen-world-rescue"]')) return;
  var anchor = document.querySelector('script[src*="whyshift-carousel.js"]');
  if (!anchor || !anchor.src) return;
  var script = document.createElement('script');
  script.src = anchor.src.replace('whyshift-carousel.js', 'whyshift-seen-world-rescue.js');
  script.defer = true;
  document.head.appendChild(script);
}

function scheduleSeenWorldRescue() {
  loadSeenWorldRescue();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleSeenWorldRescue);
} else {
  scheduleSeenWorldRescue();
}

window.addEventListener('pageshow', scheduleSeenWorldRescue);
